import { getEnvVar } from '../helpers/environment'

const digitalPrescreenUrl = getEnvVar('DIGITAL_PRESCREEN_URL')
async function getToken() {
  try {
    const res = await fetch(`${digitalPrescreenUrl}/token`)
    const data = await res.json()
    const { token } = data
    return token
  } catch (e) {
    return null
  }
}

async function getAffiliateCardOffer(token, strategyId, lineAmount) {
  const res = await fetch(
    `${digitalPrescreenUrl}/affiliates/lendingTree/offers?strategyId=${strategyId}&la=${lineAmount}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  if (res.status !== 200) {
    throw new Error('Unable to get affiliate card offer')
  }
  const data = await res.json()
  return data
}

export { getToken, getAffiliateCardOffer }
